import { createReducer } from '@reduxjs/toolkit';
import {
  getAccountDetailsSuccess,
  getAccountDetailsFailure,
  getAccountDetails,
  setSelectedAccountId,
} from '../../actions/accountDetailsActions';

const initialState = {
  data: {},
  isLoading: false,
  selectedAccountId: null,
};
const accountDetailsReducer = createReducer(initialState, builder => {
  builder
    .addCase(getAccountDetails, state => ({ ...state, isLoading: true }))
    .addCase(getAccountDetailsSuccess, (state, action) => ({ ...state, data: action.payload, isLoading: false }))
    .addCase(getAccountDetailsFailure, state => ({ ...state, isLoading: false }))
    .addCase(setSelectedAccountId, (state, action) => ({ ...state, selectedAccountId: action.payload }))
    .addDefaultCase(state => state);
});

export default accountDetailsReducer;
